<script setup lang="ts">
import {onMounted, ref} from "vue";
import {Button, InputText} from "@/Components/Library";
import {Icon} from "@iconify/vue";

const props = defineProps<{
    question: {[key: string]: any; allow_multiple: boolean};
    disabled?: boolean;
}>();
const model = defineModel<Array<string> | string>();
const error = ref<string | Array<string>>(props.question.params.allow_multiple ? [""] : "");

const deleteResponse = (index: number) => {
    if (model.value.length === 1) {
        model.value = [""];
        return;
    }
    model.value.splice(index, 1);
};

const denySpace = (index) => {
    if (props.question.params.allow_multiple) {
        error.value[index] = "Spaces are not allowed in single word responses";
    } else {
        error.value = "Spaces are not allowed in single word responses";
    }

    setTimeout(() => {
        if (props.question.params.allow_multiple) {
            error.value = [""];
        } else {
            error.value = "";
        }
    }, 2000);
};

onMounted(() => {
    if (!model.value) {
        model.value = props.question.params.allow_multiple ? [""] : "";
    }
});
</script>
<template>
    <div v-auto-animate>
        <h3 class="mb-3 mt-1 px-1 text-sm font-bold">Type a single word</h3>
        <template v-if="question.params.allow_multiple">
            <template v-for="(response, i) in model">
                <div class="mb-3 flex items-center gap-2" v-auto-animate>
                    <span
                        class="flex h-8 w-8 flex-none items-center justify-center rounded-full bg-askr-green font-bold leading-none text-white"
                    >
                        {{ i + 1 }}
                    </span>
                    <div class="flex grow flex-col" v-auto-animate>
                        <InputText
                            :disabled
                            v-model="model[i]"
                            placeholder="Type a single word response here..."
                            class="w-full"
                            required
                            @input="error[i] = ''"
                            @keydown.space.prevent="denySpace(i)"
                        />
                        <span v-if="error[i]" class="mt-1 text-xs text-red-600">{{ error[i] }}</span>
                    </div>
                    <Button
                        class="h-8 w-8 flex-none bg-red-500 text-white"
                        icon="mdi:minus"
                        @click="deleteResponse(i)"
                    />
                </div>
            </template>
            <div
                v-if="!question.params.response_limit || model?.length < question.params.response_limit"
                class="flex justify-end"
            >
                <button type="button" class="flex items-center gap-2" @click="model.push('')">
                    <span class="text-xs font-medium">Add another response</span>
                    <span
                        class="mb-1 flex h-8 w-8 items-center justify-center rounded-full border border-askr-green text-askr-green"
                    >
                        <Icon icon="mdi:plus" />
                    </span>
                </button>
            </div>
        </template>
        <template v-else>
            <div class="flex grow flex-col" v-auto-animate>
                <InputText
                    :disabled
                    v-model="model"
                    @input="error = ''"
                    @keydown.space.prevent="denySpace(null)"
                    placeholder="Type a single word response here..."
                    class="w-full"
                />
                <span v-if="error" class="mt-1 text-xs text-red-600">{{ error }}</span>
            </div>
        </template>
    </div>
</template>
<style scoped></style>
